import { render, staticRenderFns } from "./DataRegionPopover.vue?vue&type=template&id=cac6ed62&"
import script from "./DataRegionPopover.vue?vue&type=script&lang=js&"
export * from "./DataRegionPopover.vue?vue&type=script&lang=js&"
import style0 from "./DataRegionPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports